export default __webpack_public_path__ + "static/media/preview.8828394c.png";